import { PrimaryKey } from '@/generated/graphql'

// ID on url can not includes # so need replace to other character
export const buildCompositeKey = (shardId: string, id: string) => `${shardId}|${id}`.replace('#', '*')

export const getPrimaryKey = (key: string) => {
  const [shardId, id] = key.replace('*', '#').split('|')
  return { shardId, id }
}

export const getLibraryIdByShardId = (shardId: string) => {
  const [, partition] = shardId.split('#')
  const libraryKeys = partition.split('.').slice(0, -1)
  return libraryKeys.join('.')
}

export const getKeyFromString = (key: string): PrimaryKey => {
  try {
    return JSON.parse(key) as PrimaryKey
  } catch (e) {
    console.error(e)
    return { Id: '', ShardId: '' }
  }
}

export const removePrefix = (str: string | undefined, prefix: string): string => {
  if (!str) return ''
  return str.replace(new RegExp(`^${prefix}`), '')
}
